import { supabase } from '@/lib/supabase';

/**
 * PREMIUM "FREE WEBSITE INCLUDED" FULFILMENT — single source of truth.
 * Rows are created SERVER-SIDE only (payment-webhook / payment-claim on a Premium
 * activation or upgrade, one per member). Members can edit only their intake
 * answers; status / website_url / admin_notes are admin-only (DB trigger).
 */
export type WebsiteStatus = 'requested' | 'in_progress' | 'delivered';
export const WEBSITE_STATUSES: WebsiteStatus[] = ['requested', 'in_progress', 'delivered'];

export const WEBSITE_STATUS_LABEL: Record<WebsiteStatus, { en: string; es: string; cls: string }> = {
  requested: { en: 'Requested', es: 'Solicitado', cls: 'bg-amber-100 text-amber-800' },
  in_progress: { en: 'In progress', es: 'En progreso', cls: 'bg-blue-100 text-blue-800' },
  delivered: { en: 'Delivered', es: 'Entregado', cls: 'bg-emerald-100 text-emerald-800' },
};

export interface WebsiteRequest {
  id: string;
  user_id: string;
  email: string | null;
  company_name: string | null;
  trade: string | null;
  city: string | null;
  state: string | null;
  status: WebsiteStatus;
  business_name: string | null;
  logo_url: string | null;
  services: string | null;
  phone: string | null;
  intake_submitted_at: string | null;
  website_url: string | null;
  admin_notes: string | null;
  created_at: string;
  started_at: string | null;
  delivered_at: string | null;
}

export const WEBSITE_BUCKET = 'website-assets';

export const fetchMyWebsiteRequest = async (userId?: string | null): Promise<WebsiteRequest | null> => {
  if (!userId) return null;
  const { data } = await supabase.from('mkt_website_requests').select('*').eq('user_id', userId).maybeSingle();
  return (data as WebsiteRequest) || null;
};

/** Upload a logo into the member's own folder (storage policy enforces the folder). */
export const uploadLogo = async (userId: string, file: File): Promise<string> => {
  const ext = (file.name.split('.').pop() || 'png').toLowerCase().replace(/[^a-z0-9]/g, '') || 'png';
  const path = `${userId}/logo-${Date.now()}.${ext}`;
  const { error } = await supabase.storage.from(WEBSITE_BUCKET).upload(path, file, { upsert: true, contentType: file.type || undefined });
  if (error) throw error;
  return supabase.storage.from(WEBSITE_BUCKET).getPublicUrl(path).data.publicUrl;
};
